import React from 'react';
import { Link } from 'react-router-dom';
import MainContainer from '../containers/main';

const PasswordResetInvalid = () => {
    return (
        <MainContainer>
            <>
                <h1>Link expired</h1>
                <p className="mt-4">Unfortunately, this password reset link has expired.</p>
                <Link to="/forgot-your-password/" className="btn mt-4 btn--primary-green">Request a new link</Link>

            </>
        </MainContainer>

    );
};

export default PasswordResetInvalid;
